<template>
<v-container fluid>
    <template v-if="passwordToken">
        <p v-if="resetPending" v-html="$t('__long.user.recovery.waiting')"></p>
        <p v-else v-html="$t('__long.user.recovery.done')"></p>
    </template>
    <template v-else>
        <v-card>
            <v-card-title v-html="$t('Direct Reset E-Mail')"></v-card-title>
            <v-card-text v-html="$t('__long.user.recovery.alert')"></v-card-text>
            <v-card-text v-if="!directEmail" class="red--text" v-t="'__long.user.recovery.alert disabled'"></v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn :disabled="!directEmail" v-t="'Send Recovery E-Mail'" @click="sendEmail" color="primary"></v-btn>
            </v-card-actions>
        </v-card>
        <v-card class="mt-3">
            <v-card-title v-html="$t('Contact Espec Support for Reset E-Mail')"></v-card-title>
            <v-card-text v-html="$t('__long.user.recovery.offline')"></v-card-text>
            <v-card-text class="pt-0">
                <v-row dense>
                    <v-col md="4" lg="3">
                        <p v-html="$t('__long.user.recovery.img')"></p>
                        <div ref="qr"></div>
                    </v-col>
                    <v-col md="8" lg="9">
                        <div style="min-width: 300px;">
                            <p v-t="'__long.user.recovery.manual'"></p>
                            <v-text-field readonly :label="$t('To')" v-model="mailTo"/>
                            <v-text-field readonly :label="$t('Subject')" v-model="mailSubject"/>
                            <v-textarea readonly outlined :label="$t('Message')" v-model="mailBody"/>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn :href="mailHref" v-html="$t('Open E-Mail Client')" color="primary"></v-btn>
            </v-card-actions>
        </v-card>
    </template>
</v-container>
</template>

<script>
import EspecAuthApi from '@/services/EspecAuthApi.js';
import qrcode from 'qrcode-generator';

export default {
    data () { return {
        mailTo: 'support@espec.com',
        mailSubject: 'Web Controller V3 Password Reset',
        offlineToken: '',
        passwordToken: null,
        resetPending: true,
        directEmail: false
    }},
    computed: {
        mailBody () { return `I need help recovering my password.\n\n<token>${this.offlineToken}</token>`},
        mailHref () { return `mailto:${this.mailTo}?subject=${this.mailSubject}&body=${this.mailBody}`; }
    },
    methods: {
        updateOfflineQR () {
            let qr = qrcode(0, 'L');
            qr.addData(this.mailHref);
            qr.make();
            this.$refs.qr.innerHTML = qr.createImgTag(4, 4);
        },
        sendEmail () {
            EspecAuthApi.getRecoveryEmail();
        }
    },
    mounted () {
        this.passwordToken = this.$route.params.token ? this.$route.params.token : null;
        if (!this.passwordToken) {
            EspecAuthApi.getRecovery().then(r => {
                this.offlineToken = JSON.stringify({token: r.token, ip: r.ip});
                this.directEmail = r.direct_email
                this.updateOfflineQR();
            });
        }
        else {
            EspecAuthApi.putRecovery({password: this.passwordToken}).then(r => {
                this.$emit('success');
                this.$router.push('/user');
            });
        }
    }
}
</script>